<template>
  <div>
    <!-- 触发抽屉显示的按钮 -->
    <el-button
      class="live-chat-button-container"
      @click="drawer = true"
      type="primary"
      style="position: fixed; bottom: 20px; right: 20px"
      src="../assets/image/在线客服.png"
    >
      <img
        src="../assets/image/在线客服.png"
        alt="在线客服"
        style="width: 30%; height: 30px; margin-bottom: -16px"
      />
      在线客服
    </el-button>

    <!-- 抽屉式对话框 -->
    <el-drawer
      style="padding: 10px"
      class="custom-drawer"
      title="我是标题"
      :visible.sync="drawer"
      :with-header="false"
      direction="rtl"
      size="10%"
      @close="drawer = false"
    >
      <div class="top">
        <p class="online">在线客服</p>
        <p class="text">客服二维码</p>
        <img class="code" src="../assets/image/客服二维码.png" alt="" />
        <el-divider></el-divider>
        <p class="text">联系电话</p>
        <p class="content">18100681818</p>
        <el-divider></el-divider>
        <p class="text">公司地址</p>
        <p class="content">苏州市吴江区云创路229号2层</p>
        <el-divider></el-divider>
        <p class="text">联系我们</p>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false, // 控制抽屉是否显示的变量
    };
  },
  methods: {
    closeChat() {
      this.isChatOpen = false;
      this.chatMessages = []; // 清除聊天记录 this.newMessage = ""; // 清空输入框
    },
  },
};
</script>

<style scoped>
/* 样式可以根据需要调整 */
.live-chat-button-container {
  writing-mode: vertical-rl; /* 竖直从右到左排列文字 */
  text-orientation: upright; /* 保持文字正向显示，不旋转 */
  padding: 10px 6px;
  background-color: rgba(32, 150, 214, 0.975);
  color: white;
  letter-spacing: 5px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* 添加阴影以增加立体感 */
  transition: all 0.3s ease; /* 添加过渡效果，使按钮的悬停和点击效果更平滑 */
}
.el-drawer__open {
  overflow: hidden;
}
.custom-drawer {
  margin-top: 300px;
  height: 500px;
  padding: 10px;
}
.top {
  height: 50px;
  padding: 10px;
  background-color: rgba(32, 150, 214, 0.975);
  color: rgba(32, 150, 214, 0.975);
}
.online {
  font-size: 19px;
  color: white;
  height: 50px;
  line-height: 32px;
}
.code {
  margin-top: 10px;
  width: 90%;
  height: auto;
  box-shadow: 2px 2px 2px 2px rgba(73, 72, 72, 0.75);
}
.content {
  color: rgb(66, 64, 64);
  font-size: 12px;
  margin-top: 10px;
}
</style>
